import * as React from "react"
import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode
  unit?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, unit, disabled, ...props }, ref) => {
    return (
      <div className="relative flex items-center">
        <div className="relative flex-1">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-300">{icon}</div>
          )}
          <input
            type={type}
            className={cn(
              "flex h-8 w-full rounded-[5px] border border-slate-300 bg-white px-3 py-2 text-sm text-[#3f4652] placeholder:text-slate-300",
              "file:border-0 file:bg-transparent file:text-sm file:font-medium",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-0 focus-visible:border-slate-300",
              "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:border-slate-200 disabled:text-slate-300",
              icon && "pl-10",
              className
            )}
            ref={ref}
            disabled={disabled}
            {...props}
          />
        </div>
        {unit && <span className="ml-1.5 text-sm font-semibold text-[#3f4652]">{unit}</span>}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
